import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelComponent } from '../panel/panel.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ClientOrderService } from '../services';

@Component({
  selector: 'webmodule-order-panel-customer',
  imports: [CommonModule, PanelComponent, TranslatePipe],
  templateUrl: './panel-customer.component.html',
  styles: `:host {
      display: block;
  }`,
  standalone: true,
})
export class PanelCustomerComponent {
  private readonly orderService = inject(ClientOrderService);
  readonly customer = this.orderService.customer;
  readonly address = this.orderService.address;
}
